/* eslint-disable react-hooks/exhaustive-deps,import/no-unresolved */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isBrowser } from 'react-device-detect';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { WhitelistVerifyComponent } from 'assets/components';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { SendCryptoScreensFlow } from '../../constants';
import { useUserPersonalInfo } from '../../../../utilities/sharedHooks/user';
import Countdown from '../../../../utilities/counter';
import { starPhoneNumber } from '../../../../utilities/helpers';
import { PHONE_VERIFICATION_SEND_AUTHY } from '../../../../utilities/sharedMutations';
import { showAlert } from '../../../../utilities/notifications';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import { RECAPTCHA_EVENTS } from '../../../Onboarding/constants';
import {
  WHITELIST_ADDRESSES,
  WHITELIST_AUTH_EMAIL,
  WHITELIST_DELETE_WALLET,
} from '../../mutations';
import { LEDGER_BAANX_CURRENCY_NAME_MAP } from '../../../../utilities/constants';
import RecaptchaModal from '../../../shared/RecaptchaModal';
import { cacheRecaptchaV3failure, clearRecaptchaV3failure } from '../../../../utilities/caching';

const emailCountdown = new Countdown();
const phoneCountdown = new Countdown();
const REASONS = {
  DELETE: 'white_list_delete_address',
  ADD: 'white_list_add_address',
};
const WhitelistVerify = ({ openScreen, options, isSendCryptoModal }) => {
  const { t: translate } = useTranslation();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isOpenRecV2, setIsOpenRecV2] = useState(false);
  const [recV2Token, setRecV2Token] = useState('');
  const [isRecaptchaV3failedEmailCode, setIsRecaptchaV3failedEmailCode] = useState(false);

  const {
    email,
    phoneNumber,
    countryCode,
    totpEnabled,
    totpActive,
    authyId,
    id: userId,
  } = useUserPersonalInfo();
  const { selectedWallet } = options;

  const [totpFeatureEnabled] = useSetting('app_features', 'feature_allow_totp');
  const [totpConfirmationEnabled] = useSetting(
    'server_configurations',
    'feature_enable_totp_confirmation_for_whitelist'
  );
  const [emailConfirmationEnabled] = useSetting(
    'server_configurations',
    'feature_enable_email_confirmation_for_whitelist'
  );

  const [phoneCode, setPhoneCode] = useState('');
  const [emailCode, setEmailCode] = useState('');

  const [emailCounter, setEmailCounter] = useState();
  const [phoneCounter, setPhoneCounter] = useState();

  const isUsingTotp = totpEnabled && totpActive && totpFeatureEnabled;

  const targetWallets = useMemo(() => {
    if (options.wallets) {
      return options.wallets.map((_wallet) => ({
        wallet_id: _wallet.id,
        wallet_address: _wallet.address,
        coin: _wallet.currency || LEDGER_BAANX_CURRENCY_NAME_MAP[_wallet.coin],
        supported_currencies_id: _wallet.coin_id,
        name: _wallet.name,
        memo: _wallet.memo,
        beneficiary_first_name: _wallet.beneficiary_first_name,
        beneficiary_last_name: _wallet.beneficiary_last_name,
      }));
    }
    return [];
  }, []);

  const { mutate: send2faCode, isLoading: isLoadingSend2FACode } = useMutation(
    PHONE_VERIFICATION_SEND_AUTHY,
    {
      onSettled(_, error) {
        if (error) {
          if (error?.response?.status === 307) {
            setIsOpenRecV2(true);
            setIsRecaptchaV3failedEmailCode(false);
            cacheRecaptchaV3failure();
          } else {
            setIsOpenRecV2(false);
            clearRecaptchaV3failure();
            showAlert({ message: error.message, type: 'danger' });
          }
        } else {
          setIsOpenRecV2(false);
          clearRecaptchaV3failure();
          phoneCountdown.start();
        }
      },
    }
  );

  const handleSend2faCode = async () => {
    if (isUsingTotp) {
      // Google Auth
    } else {
      // SMS 2FA
      try {
        const token = await executeRecaptcha(RECAPTCHA_EVENTS.VERIFY_PHONE_NUMBER);
        if (!token) {
          showAlert({ message: translate('whitelist_recaptcha_error'), type: 'danger' });
        }

        send2faCode({ authy_id: authyId, user_id: userId, token });
      } catch (err) {
        showAlert({ message: err?.message, type: 'danger' });
      }
    }
  };

  const { mutate: sendEmailCode } = useMutation(WHITELIST_AUTH_EMAIL, {
    onSettled(_, error) {
      if (error) {
        if (error?.response?.status === 307) {
          setIsOpenRecV2(true);
          setIsRecaptchaV3failedEmailCode(true);
          cacheRecaptchaV3failure();
        } else {
          setIsOpenRecV2(false);
          clearRecaptchaV3failure();
          showAlert({ message: error.message, type: 'danger' });
        }
      } else {
        setIsOpenRecV2(false);
        clearRecaptchaV3failure();
        emailCountdown.start();
        if (emailConfirmationEnabled && totpConfirmationEnabled) {
          handleSend2faCode();
        }
      }
    },
  });

  const { mutate: whitelistAddresses, isLoading: isWhitelisting } = useMutation(
    WHITELIST_ADDRESSES,
    {
      onSettled(_, error) {
        if (error) {
          showAlert({ message: error.message, type: 'danger' });
        } else {
          showAlert({
            message: translate('whitelist_message_success_add_wallets'),
            type: 'success',
          });
          openScreen(
            isSendCryptoModal
              ? SendCryptoScreensFlow.SEND_CRYPTO
              : SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES,
            { selectedWallet: targetWallets[0] }
          );
        }
      },
    }
  );

  const { mutate: deleteWhitelistedAddress, isLoading: isDeletingWhitelist } = useMutation(
    WHITELIST_DELETE_WALLET,
    {
      onSettled(_, error) {
        if (error) {
          showAlert({ message: error.message, type: 'danger' });
        } else {
          showAlert({ message: translate('whitelist_message_remove_address'), type: 'success' });
          openScreen(SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES);
        }
      },
    }
  );

  const handleSendEmailCode = async () => {
    const token = await executeRecaptcha(RECAPTCHA_EVENTS.WHITELIST_AUTH_EMAIL);
    if (!token) {
      return;
    }
    const reason = options?.isDelete ? REASONS.DELETE : REASONS.ADD;
    const wallets = options?.isDelete ? [options.selectedWallet] : targetWallets;
    sendEmailCode({ token, reason, wallets });
  };

  const resendEmailCode = () => {
    handleSendEmailCode();
  };
  const resendPhoneCode = () => {
    handleSend2faCode();
  };

  const nextScreen = () => {
    if (options?.isDelete) {
      deleteWhitelistedAddress({
        walletsIds: [options.selectedWallet.id],
        emailAuthCode: emailCode,
        authCode: phoneCode,
      });
    } else {
      whitelistAddresses({
        walletAddresses: targetWallets,
        emailAuthCode: emailCode,
        authCode: phoneCode,
      });
    }
  };

  useEffect(() => {
    if (!emailConfirmationEnabled && !totpConfirmationEnabled) {
      nextScreen();
    }

    if (emailConfirmationEnabled && totpConfirmationEnabled) {
      emailCountdown.bind(setEmailCounter);
      phoneCountdown.bind(setPhoneCounter);

      // TODO: In this case handleSend2faCode will be call after sendEmailCode successfully: issue related to recaptcha V2
      handleSendEmailCode();
    } else if (emailConfirmationEnabled) {
      emailCountdown.bind(setEmailCounter);
      handleSendEmailCode();
    } else if (totpConfirmationEnabled) {
      phoneCountdown.bind(setPhoneCounter);
      handleSend2faCode();
    }

    return () => {
      if (emailConfirmationEnabled) emailCountdown.stop();
      if (totpConfirmationEnabled) phoneCountdown.stop();
    };
  }, []);

  const starredPhoneNumber = useCallback(
    () => starPhoneNumber(`${countryCode}${phoneNumber}`),
    [countryCode, phoneNumber]
  );

  const renderTitle = () => (
    <div
      className={`w-100 ${isBrowser ? 'd-flex align-items-center justify-content-between' : ''} `}>
      <div>
        <b className="text-f5 text-dark ms-2">{translate('whitelist_verify_title')}</b>
      </div>
    </div>
  );

  const isLoading = isWhitelisting || isDeletingWhitelist;

  const isBtnDisabled = useMemo(() => {
    if (totpConfirmationEnabled && emailConfirmationEnabled) {
      return !emailCode || !phoneCode;
    }
    if (totpConfirmationEnabled) {
      return !phoneCode;
    }
    return !emailCode;
  }, [totpConfirmationEnabled, emailConfirmationEnabled, emailCode, phoneCode]);

  const renderFooter = () => (
    <button
      onClick={nextScreen}
      disabled={isBtnDisabled}
      className="btn btn-primary w-100 mt-auto"
      type="submit">
      {translate('verify')}
    </button>
  );

  const onChangeRecV2 = async (tokenV2) => {
    setRecV2Token(tokenV2);
    if (isRecaptchaV3failedEmailCode) {
      setIsRecaptchaV3failedEmailCode(false);
      const reason = options?.isDelete ? REASONS.DELETE : REASONS.ADD;
      const wallets = options?.isDelete ? [options.selectedWallet] : targetWallets;
      sendEmailCode({ token: tokenV2, reason, wallets });
    } else {
      send2faCode({ authy_id: authyId, user_id: userId, token: tokenV2 });
    }
  };

  const prevScreen = useMemo(() => {
    if (options?.isDelete) {
      return SendCryptoScreensFlow.WHITELIST_DELETE_ADDRESS;
    }
    if (options?.isLedgerAddress) {
      return SendCryptoScreensFlow.WHITELIST_WALLET_ADDRESS_LEDGER;
    }
    return SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL;
  }, [options]);

  return (
    <>
      <ModalBodyLayout
        withBack={totpConfirmationEnabled || emailConfirmationEnabled}
        onPrevClick={() => openScreen(prevScreen, { selectedWallet })}
        renderFooter={totpConfirmationEnabled || emailConfirmationEnabled ? renderFooter : null}
        renderTitle={totpConfirmationEnabled || emailConfirmationEnabled ? renderTitle : null}
        title={null}
        isScrollable>
        {isLoading && (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="spinner-border spinner-border-md" role="status" />
          </div>
        )}
        {!isLoading && (
          <div className="d-flex flex-fill flex-column justify-content-start align-content-center h-100">
            <WhitelistVerifyComponent
              email={email}
              emailCode={emailCode}
              emailCounter={emailCounter}
              emailConfirmationEnabled={emailConfirmationEnabled}
              resendEmailCode={resendEmailCode}
              setEmailCode={setEmailCode}
              phoneCode={phoneCode}
              phoneCounter={phoneCounter}
              setPhoneCode={setPhoneCode}
              resendPhoneCode={resendPhoneCode}
              isUsingTotp={isUsingTotp}
              starredPhoneNumber={starredPhoneNumber}
              totpConfirmationEnabled={totpConfirmationEnabled}
            />
          </div>
        )}
      </ModalBodyLayout>
      <RecaptchaModal
        onChange={onChangeRecV2}
        isLoading={isLoadingSend2FACode}
        resetToken={() => setRecV2Token('')}
        token={recV2Token}
        setIsModalVisible={setIsOpenRecV2}
        isModalVisible={isOpenRecV2}
      />
    </>
  );
};

export default WhitelistVerify;

WhitelistVerify.propTypes = {
  openScreen: PropTypes.func.isRequired,
  options: PropTypes.object,
  isSendCryptoModal: PropTypes.bool,
};
WhitelistVerify.defaultProps = {
  options: {},
  isSendCryptoModal: true,
};
